export default class ResetStatusRequest{
  public constructor(
    public dataItemId: string,
    public popIndexed: boolean,
    public popDataCollected: boolean,
    public popDataQualityAssured: boolean
  ){}
}
